import { render, staticRenderFns } from "./gen.vue?vue&type=template&id=0c478576&scoped=true&"
import script from "./gen.vue?vue&type=script&lang=js&"
export * from "./gen.vue?vue&type=script&lang=js&"
import style0 from "./gen.vue?vue&type=style&index=0&id=0c478576&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c478576",
  null
  
)

export default component.exports